module.exports = __webpack_public_path__ + "img/banner03.53acbe1f.png";